export const DateFormats = {
  DAY_MONTH_YEAR_TIME: 'DD.MM.YYYY HH:mm',
  DAY_MONTH_YEAR: 'DD.MM.YYYY',
  DEFAULT: 'DD.MM.YYYY',
  DEFAULT_FOR_DATEPICKER: 'dd.MM.yyyy'
};

export const PHONE_FORMAT = '+1 (111) 111-11-11';
